import { useState } from "react";
import { SavePropertyBusinessSource } from "../../Services/Service";
import Hearder from "../commun/Hearder"
import SideBar from "../commun/SideBar"
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

export const BusinessSource = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ID: 0,
        Code: "",
        BusinessSource: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const result = await SavePropertyBusinessSource(formData);

            swal("Business Source added successfully!", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                navigate("/Property/BusinessSourceList", { state: { showSuccess: true } });
            });
            // reset form
            setFormData({ ID: 0, Code: "", BusinessSource: "" });
            console.log(result);
        } catch (error) {
            console.log("Error saving Business Source", error);
            alert("Failed to save Business Source");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">Property Busniness Source </div>
                                        </div>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Code</label>
                                                            <input type="number" className="form-control" placeholder="Enter Code" name="Code" value={formData.Code}
                                                                onChange={handleChange} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Business Source</label>
                                                            <input type="text" className="form-control" placeholder="Enter Business Source" name="BusinessSource" value={formData.BusinessSource}
                                                                onChange={handleChange} required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-action text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        submit
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
